<form class="app-form" [formRoot]="form">
  <div id="userDetails">
    <h4>{{ 'MESSAGES.INFOS.LETS_GET_STARTED' | translate }}</h4>
    <p>
      {{ 'MESSAGES.PROMPTS.ALREADY_HAVE_ACCOUNT' | translate }}<a
        class="ml-2 cursor-pointer"
        [routerLink]="'/auth/login'"
        >{{ 'LABELS.LOGIN' | translate }}</a
      >
    </p>
    <div class="flex flex-wrap -mx-gutter">
      <div class="relative w-full px-gutter sm:w-1/2">
        <div class="form-group">
          <label class="col-form-label label-required">{{ 'LABELS.FIRST_NAME' | translate }}</label>
          <input
            class="form-control"
            type="text"
            [formField]="form.firstName"
            placeholder="{{ 'MESSAGES.PROMPTS.ENTER_FIRST_NAME' | translate }}"
            autocomplete="given-name"
            inputmode="text"
            appFormFieldOnError
            [customMessages]="{ required: 'MESSAGES.ERRORS.FIRST_NAME_REQUIRED' | translate }"
          />
        </div>
      </div>
      <div class="relative w-full px-gutter sm:w-1/2">
        <div class="form-group">
          <label class="col-form-label label-required">{{ 'LABELS.LAST_NAME' | translate }}</label>
          <input
            class="form-control"
            type="text"
            [formField]="form.lastName"
            autocomplete="family-name"
            inputmode="text"
            placeholder="{{ 'MESSAGES.PROMPTS.ENTER_LAST_NAME' | translate }}"
            appFormFieldOnError
            [customMessages]="{ required: 'MESSAGES.ERRORS.LAST_NAME_REQUIRED' | translate }"
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <label class="col-form-label label-required">{{ 'LABELS.BUSINESS_NAME' | translate }}</label>
      <input
        class="form-control"
        type="text"
        [formField]="form.entityName"
        autocomplete="organization"
        placeholder="{{ 'MESSAGES.PROMPTS.ENTER_BUSINESS_NAME' | translate }}"
        appFormFieldOnError
        [customMessages]="{
          required: 'MESSAGES.ERRORS.BUSINESS_NAME_REQUIRED' | translate,
          pattern: 'MESSAGES.ERRORS.BUSINESS_NAME_INVALID' | translate,
        }"
      />
    </div>
    <div class="form-group">
      <label class="col-form-label label-required">{{ 'LABELS.COUNTRY' | translate }}</label>
      <ng-select
        [items]="countryList()"
        [formField]="form.country"
        bindLabel="Name"
        bindValue="Name"
        class="form-control-inverse btn-square ng-select-outline"
      >
      </ng-select>
    </div>
    <button class="btn btn-gradient btn-block mt-12" type="submit" [disabled]="form().invalid() || form().submitting()">
      {{ 'DEVELOPER.GET_STARTED.NEXT_BUTTON' | translate }}
    </button>
  </div>
</form>
